import * as zod from 'zod';

export const DEFAULT_CAMERA_CONFIGURATION = {
  fps: 0,
  width: 0,
  height: 0,
};

export const CameraConfiguration = zod.object({
  kind: zod.literal(`Camera`),
  name: zod.string().default(`Custom Camera`),
  id: zod.string().default(''),
  configuration: zod
    .object({
      fps: zod.number().int(),
      width: zod.number().int(),
      height: zod.number().int(),
    })
    .default(DEFAULT_CAMERA_CONFIGURATION),
});

export type CameraConfiguration = zod.infer<typeof CameraConfiguration>;
